import BedBuilder, { BedBuilderProps } from '@components/builder/BedBuilder'
import { PrismicImage } from '@lib/prismic'
import { FC } from 'react'
export interface PreselectedLookItem {
  preselected_look_image: PrismicImage
  preselected_look_title: string
  preselected_look_link: string
}
interface props {
  items: PreselectedLookItem[]

  bedBuilderSettings: BedBuilderProps['settings']
  colourSwatches: BedBuilderProps['colourSwatches']
  locale: BedBuilderProps['locale']
  arConfiguration: BedBuilderProps['arConfiguration']
  products: BedBuilderProps['products']
  sizeGuideModal: BedBuilderProps['sizeGuideModal']
  prismicRef: BedBuilderProps['prismicRef']
  fullscreen: BedBuilderProps['fullscreen']
  topPadding?: number
  bottomPadding?: number
}
const BedBuilderSlice: FC<props> = ({
  items,
  bedBuilderSettings,
  colourSwatches,
  locale,
  arConfiguration,
  products,
  sizeGuideModal,
  prismicRef,
  topPadding,
  bottomPadding,
}) => {
  return (
    <div className="desktop:max-w-desktop mx-auto" style={{ paddingTop: topPadding, paddingBottom: bottomPadding }}>
      {products && (
        <BedBuilder
          settings={bedBuilderSettings}
          colourSwatches={colourSwatches}
          locale={locale || undefined}
          arConfiguration={arConfiguration}
          products={products}
          sizeGuideModal={sizeGuideModal}
          prismicRef={prismicRef}
          fullscreen={false}
          preselectedLooks={items}
          key={`${locale}-bed-builder`}
        />
      )}
    </div>
  )
}

export default BedBuilderSlice
